import React from 'react'
import moment from 'moment-timezone'

export default ({ date }) => {
  const parsed = moment.parseZone(date)
  let format = 'D MMM YYYY'
  if (parsed.hour() !== 0 || parsed.minute() !== 0 || parsed.second() !== 0) {
    format += ' LT'
  }
  if (parsed.utcOffset() !== 0) {
    format += ' Z'
  }
  return (
    <>
      {moment.parseZone(date).format(format)}
    </>
  )
}
